import NewLoggerInterface from './loggerInterface';
import { NewLoggerInterfaceType } from '@clientos/types';

import {
  createBareboneLogger,
  newInternalLogger
} from '../../../services/loggerService/createBareboneLogger';

let loggerInterface: NewLoggerInterface;

// Create a barebone logger to be used before the full load.
createBareboneLogger();

export { newInternalLogger as internalLogger };

export default async function initializeLoggerInterface(): Promise<NewLoggerInterfaceType> {
  if (loggerInterface) return loggerInterface.getInterface();
  loggerInterface = new NewLoggerInterface();

  return loggerInterface.getInterface();
}
